/*
 * Die Sätze des Verlassen-Wächters der Bereiche Angebote und Aufträge (Hausregel „Texte in Properties“): Schlüssel
 * englisch, Werte deutsch. Eine Frage beim offenen Bearbeiten und eine beim offenen Erfassen (Anlage, historisches Panel;
 * Gesamtreview A-W3) — sonst gingen Eingaben, gewählte Dateien und Ergebnisse des Hochladens bei Navigation still verloren.
 */
export const LEAVE_TEXT = {
  title: "Seite verlassen?",
  confirm: "Verlassen",
  offerEditing: "Dieses Angebot ist noch in Bearbeitung. Nicht gespeicherte Eingaben gehen verloren.",
  orderEditing: "Dieser Auftrag ist noch in Bearbeitung. Nicht gespeicherte Eingaben gehen verloren.",
  offerCreating: "Ein Angebot wird gerade erfasst. Nicht gespeicherte Eingaben und gewählte Dateien gehen verloren.",
  orderCreating: "Ein Auftrag wird gerade erfasst. Nicht gespeicherte Eingaben und gewählte Dateien gehen verloren.",
} as const;
